export default {
  GET_ADMIN_MENU_REQUESTED: 'GET_ADMIN_MENU_REQUESTED',
  GET_ADMIN_MENU_FAILED: 'GET_ADMIN_MENU_FAILED',
  GET_ADMIN_MENU_SUCCEEDED: 'GET_ADMIN_MENU_SUCCEEDED',
};
